import React, { useState } from 'react'
import { Panel } from 'rsuite'
import { useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import {
  sessionSetItemStr,
  sessionRemoveItem,
  sessionGetItemJSON,
} from '../../utils/sessionHelpers'
import { startLoading, doneLoading } from '../../utils/loading'
import BorrowAvanceVoucherListTable from './BorrowAvanceVoucherListTable'
import { searchBorrowAdvanceList } from '../../redux/actions/paymentRecordAdvance'
import { cloneDeep } from 'lodash-es'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import MiniProjectInfo from './MiniProjectInfo'
import AccountingPeriodWidget from '../panelHeder/AccountingPeriodWidget'

//รายละเอียดการบันทึกยืม-คืนเงินทดรองจ่าย
export default function BorrowAvanceVoucherListWidget(props) {
  const { periodNumber, projectCode } = props

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  // const [formSchema, setFormSchema] = useState(mockSchema)

  const history = useHistory()

  const periodInfo = sessionGetItemJSON('periodInfo')

  const handleSearch = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await searchBorrowAdvanceList(request, projectCode, periodNumber)
      // console.log('resssss 99999 ', response)
      let _schema = cloneDeep(formSchema)
      _schema.datas = response.model
      setFormSchema(_schema)
    } catch (error) {
      // console.log('error ', error)

      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleSelect = (rowData, type) => {
    // console.log('rowData ', rowData)

    // กรณีกดแก้ไขข้อมูล
    if (rowData) {
      sessionSetItemStr('borrowId', rowData.id)
    } else {
      sessionRemoveItem('borrowId')
    }

    if (type == '1') {
      //ยืมเงินทดรองจ่าย
      history.push({
        pathname: pathname.incomeAndExpense.BorrowAdvancePaymentRecord,
      })
    } else {
      //คืนเงินทดรองจ่าย
      history.push({
        pathname: pathname.incomeAndExpense.BorrowAdvanceRefund,
      })
    }
  }

  return (
    <>
      <Panel
        shaded
        collapsible
        defaultExpanded
        header={<AccountingPeriodWidget periodInfo={periodInfo} />}
        bordered
      >
        {formSchema?.projectInfo && (
          <>
            <MiniProjectInfo schema={formSchema.projectInfo} />
            <br />
          </>
        )}

        <BorrowAvanceVoucherListTable
          schema={formSchema}
          loading={isLoading}
          onSelect={handleSelect}
          onSearch={handleSearch}
        />

        {isLoading && <OverlayLoader />}
      </Panel>
    </>
  )
}
